import React from "react";
import { Form, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { updateBulkValues } from "../../../infrastructure/slices/bulkSelectSlice/bulkSelectSlice";
import AsyncSelect from "react-select/async";

interface BulkFieldInputProps {
  field: {
    field: string;
    options?: { label: string; value: string }[];
    date?: boolean;
  };
  bulkValues: { field: string; value: string }[];
  required?: boolean;
}

const BulkFieldInput: React.FC<
  BulkFieldInputProps & {
    relationAsyncOptions?: { label: string; value: string }[];
    relationAsyncLoader?: (
      input: string,
      callback: (options: { label: string; value: string }[]) => void,
    ) => void;
  }
> = ({
  field,
  bulkValues,
  relationAsyncOptions,
  relationAsyncLoader,
  required,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");

  const handleChange = (value: string) => {
    if (Array.isArray(bulkValues)) {
      dispatch(
        updateBulkValues([
          ...bulkValues.filter((item) => item.field !== field.field),
          { field: field.field, value },
        ]),
      );
    }
  };

  if (field.date) {
    return (
      <Col className={"mt-3"}>
        <Form.Group>
          <Form.Label>
            {t(`crud.table.${field.field}`)}
            {required && <span style={{ color: "red" }}> *</span>}
          </Form.Label>
          <Form.Control
            type="date"
            name={t(field.field)}
            value={
              bulkValues?.find((item) => item.field === field.field)?.value ||
              ""
            }
            onChange={(event) => handleChange(event.target.value)}
          />
        </Form.Group>
      </Col>
    );
  } else if (field.field === "relation") {
    return (
      <Col className={"mt-3"}>
        <Form.Group>
          <Form.Label>
            {t(`crud.table.${field.field}`)}
            {required && <span style={{ color: "red" }}> *</span>}
          </Form.Label>
          <AsyncSelect
            cacheOptions
            defaultOptions={relationAsyncOptions}
            loadOptions={relationAsyncLoader}
            value={relationAsyncOptions?.find(
              (option) =>
                option.value ===
                bulkValues?.find((item) => item.field === field.field)?.value,
            )}
            onChange={(selected) => handleChange(selected?.value ?? "")}
            isClearable
          />
        </Form.Group>
      </Col>
    );
  } else if (field.options) {
    return (
      <Col className={"mt-3"}>
        <Form.Group>
          <Form.Label>
            {t(`crud.table.${field.field}`)}
            {required && <span style={{ color: "red" }}> *</span>}
          </Form.Label>
          <Form.Select
            name={t(field.field)}
            defaultValue={
              bulkValues?.find((item) => item.field === field.field)?.value ||
              ""
            }
            onChange={(event) => handleChange(event.target.value)}
          >
            <option value="">{t("Select")}</option>
            {field.options.map((option) => (
              <option key={option.value} value={option.value}>
                {t(option.label)}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
    );
  } else {
    return (
      <Col className={"mt-3"}>
        <Form.Group>
          <Form.Label>
            {t(`crud.table.${field.field}`)}
            {required && <span style={{ color: "red" }}> *</span>}
          </Form.Label>
          <Form.Control
            type="text"
            name={t(field.field)}
            value={
              bulkValues?.find((item) => item.field === field.field)?.value ||
              ""
            }
            onChange={(event) => handleChange(event.target.value)}
          />
        </Form.Group>
      </Col>
    );
  }
};

export default BulkFieldInput;
